var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4C3.79086 4 2 5.79086 2 8V17C2 18.6569 3.34315 20 5 20H7H11H14H15H16H19C20.6569 20 22 18.6569 22 17V13C22 10.7909 20.2091 9 18 9H16V8C16 5.79086 14.2091 4 12 4H6ZM11 17V18H14V10V9V8C14 6.89543 13.1046 6 12 6H6C4.89543 6 4 6.89543 4 8V17C4 17.5523 4.44772 18 5 18H7V17C7 16.4477 7.44772 16 8 16H10C10.5523 16 11 16.4477 11 17ZM16 11V18H19C19.5523 18 20 17.5523 20 17V13C20 11.8954 19.1046 11 18 11H16ZM8 9C8 8.44772 8.44772 8 9 8C9.55228 8 10 8.44772 10 9V10H11C11.5523 10 12 10.4477 12 11C12 11.5523 11.5523 12 11 12H10V13C10 13.5523 9.55228 14 9 14C8.44772 14 8 13.5523 8 13V12H7C6.44772 12 6 11.5523 6 11C6 10.4477 6.44772 10 7 10H8V9Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.3b4e6c30cfe95f6b2ee9aaeba3323d49.svg";
export { ForwardRef as ReactComponent };